import React from 'react';

/**
 * Maintenance Window Icon Component
 * @description A maintenance window icon used for displaying maintenance window status
 */
export const MaintenanceWindowIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill={props.fill || 'currentColor'}
      fillRule="evenodd"
      d="M17.72 5.344a2.666 2.666 0 0 0-4.63 0L1.684 25.302A2.667 2.667 0 0 0 4 29.292h22.81a2.668 2.668 0 0 0 2.315-3.99zm-3.17 10.129-1.025 2.052-2.05 1.027-2.053-2.054c-.266 1.187.064 2.84 1.027 4.104 1.31 1.008 2.924 1.348 4.102 1.026l4.68 4.441q1.33 1.176 2.66-.156 1.415-1.413 0-2.828-4.323-4.244-4.263-4.533c.323-1.179-.018-2.792-1.027-4.104-1.264-.962-2.917-1.294-4.101-1.026z"
      clipRule="evenodd"
    />
  </svg>
);

export default MaintenanceWindowIcon;


